import { Badge, BadgeProps, MantineColor } from '@mantine/core'
import { cloneElement } from 'react'
import { FormattedMessage } from 'react-intl'
import { LabelingType } from '@/types/dataset'
import { LABELING_TYPES_CONFIG_MAP } from './LabelingTypeConfig'

function getLabelingTypeColor(labelingType: LabelingType): MantineColor {
  if (labelingType === LabelingType.ObjectDetection) {
    return 'cyan.7'
  }

  if (labelingType === LabelingType.Classification) {
    return 'yellow.7'
  }

  return 'gray'
}

type LabelingTypeChipProps = {
  labelingType: LabelingType
  size?: BadgeProps['size']
}

export const LabelingTypeChip = ({
  labelingType,
  size = 'xs'
}: LabelingTypeChipProps) => {
  const { name, icon } = LABELING_TYPES_CONFIG_MAP[labelingType]

  return (
    <Badge
      color={getLabelingTypeColor(labelingType)}
      size={size}
      leftSection={cloneElement(icon, { size: 12, stroke: 3 })}
    >
      <FormattedMessage id={name} />
    </Badge>
  )
}
